// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1-beh","footer":"Form_footer__2G6QD"};